import { assocPath, compose, last, path, prop, sortBy } from 'ramda'
import moment from 'moment'

export const HOUR_HEIGHT = 3.5
export const MINUTE_HEIGHT = HOUR_HEIGHT / 60
export const CARD_HEIGHT = 1
export const CONFLICT_INTERVAL = CARD_HEIGHT / MINUTE_HEIGHT

const hasConflict = (eventA, eventB) => {
  if (!eventA) return false
  if (!eventB) return false
  const dateA = moment(eventA.date)
  const dateB = moment(eventB.date)

  let diff = dateA.diff(dateB, 'minutes')

  if (diff < 0) diff = diff * -1
  return diff <= CONFLICT_INTERVAL
}

const calculateGroups = events => {
  let group = -1
  let row = -1
  let col = -1
  let colsMap = {}
  let groupsWidth = {}
  const formattedEvents = events.reduce((formattedEvents, event, i) => {
    const previousEvent = formattedEvents[i - 1]
    const nextEvent = events[i - 1]
    const firstEvent = previousEvent?.col === 0 ? previousEvent : previousEvent?.firstEvent
    const isNewGroup = !previousEvent || !hasConflict(previousEvent, event)
    const isNewRow = !hasConflict(firstEvent, event)

    // Reset row, cols and groups
    if (isNewGroup) {
      group++
      row = -1
      colsMap = {}
    }
    if (isNewRow) {
      row++
      col = -1
    }
    col++

    // Col data to calculate index
    // It checks if has any conflict on the same col but different rows
    // If it has it adds 1 to the index
    const colData = path([col], colsMap) || []
    const lastEventOnSameCol = last(colData)
    const index = hasConflict(lastEventOnSameCol, event) ? lastEventOnSameCol.index + 1 : 0

    // Previous index amount
    // To calculate the distanceLeft from each event
    // col + previousIndexAmount
    // const previousEventOnSameRow = \ci

    // Set the data on the event
    event = { ...event, firstEvent, group, row, col, index }

    // Update the col data with the updated event data
    colsMap = assocPath([col], [...colData, event], colsMap)

    // Build the groupsWidth map
    // It is used to calculate the width of each event in a group
    // It get the higher col and the amount of indexes bigger than 0
    let groupWidthData = path([group], groupsWidth) || { indexAmountPerCol: {}, maxCol: 0 }
    if (groupWidthData.maxCol < col) groupWidthData.maxCol = col
    // groupWidthData.indexAmount += index > 0 ? 1 : 0
    // groupWidthData.indexAmountPerCol[col] += index > 0 ? 1 : 0
    groupsWidth = assocPath([group], groupWidthData, groupsWidth)

    return [...formattedEvents, event]
  }, [])

  return [formattedEvents, groupsWidth]
}

export const calculateWidthAndPositionForConflicts = rawEvents => {
  if (!rawEvents || !rawEvents.length) return []
  const [events, groupsWidth] = compose(calculateGroups, sortBy(prop('date')))(rawEvents)

  return events.map(event => {
    const date = moment(event.date)
    const minute = date.minute()
    const distanceTop = MINUTE_HEIGHT * minute
    const groupData = groupsWidth[event.group]

    const width = 100 / (groupData.maxCol + 1) || 100
    const distanceLeft = event.col * width

    return {
      ...event,
      distanceTop,
      distanceLeft,
      width
    }
  })
}
